import { useAsync } from '@nxsys/hooks/useAsync';
import { snoozeUrgentActionApi } from '@nxsys/services/api/urgentActions';
import { SnoozeResponse } from '@nxsys/types/api/urgentActions';
import { showMessage } from '@nxsys/utils/message';
import { useEffect } from 'react';
import { getErrorMessage } from '@nxsys/utils/getErrorMessage';

export const useSnoozeUrgentAction = () => {
  const { value, loading, error, run } = useAsync<SnoozeResponse, void>(
    snoozeUrgentActionApi,
  );

  useEffect(() => {
    if (error) {
      showMessage({ type: 'error', content: getErrorMessage(error) });
    }
  }, [error]);

  return { value, loading, error, run };
};
